import { InvalidGraphqlRequest } from "./graphqlTypes";
const checkQueryReqParams = ({ id, text, name }) => {
  if (!!id && !!text) {
    throw new InvalidGraphqlRequest(`No query or query identifier are being provided on operation ${name}. Please ensure the relay-compiler ran successfully`);
  }
};
var request_default = checkQueryReqParams;
export {
  request_default as default
};
